import * as fromDatatype from '../../../../../models/datatype-library';
import { PmtStmtLineDto } from './pmt-stmt-line-dto.model';
import { PmtStmtHdrDto } from './pmt-stmt-hdr-dto.model';

export class PmtStmtLineReportDto {
    hdr: PmtStmtHdrDto;
    lines: PmtStmtLineDto[];
  }
  